export default "__VITE_ASSET__DRQ25OcL__"